<eg-card-select
  *transloco="let translate"
  [disabled]="disabled"
  [items]="debtors$ | async"
  [itemTemplate]="itemTemplate"
  [tileTemplate]="tileTemplate"
  [hideAllItemsOnEmptyQuery]="false"
  [searchPlaceholder]="translate('forms.search')"
  (dropdownClosed)="markInputAsTouched()"
  (searchValueChange)="onSearchValueChanged($event)"
  (valueSelection)="onSelect($event)"
  [value]="value"
  [clearable]="clearable"
>
</eg-card-select>

<ng-template #tileTemplate>
  <div fxFlex="100" fxLayoutAlign="start center" class="label">
    @if (selectedName) {
      <span [class.label-top]="selectedName">{{ labelWithSuffix }}</span>
    }
    <span class="selected-value">{{ selectedName || labelWithSuffix }}</span>
  </div>
</ng-template>

<ng-template #itemTemplate let-item="item" let-selectCallback="selectCallback">
  <div fxFlex="100" fxLayoutAlign="start center" class="px-16 select__item" (click)="selectCallback(item)">
    {{ item.debtorId }} - {{ item.name1 }}
    {{ item?.city ? ' - ' + item.city : '' }}
  </div>
</ng-template>

@if (control?.touched && control?.errors && errorMessage) {
  <eg-form-error [errorMessage]="errorMessage" class="input-error"></eg-form-error>
}
